import { timeToMinutes, parseIsoToMs } from '@shared/utils/timeUtils'

export const HOUR_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/

export const STATUS_STATE = Object.freeze({
  LOW_LATENCY: '#198754',
  MEDIUM_LATENCY: '#ffc107',
  HIGH_LATENCY: '#dc3545',
  OFF_MARKET: '#6c757d'
})

const LATENCY_THRESHOLD_SECONDS = Object.freeze({
  LOW_MAX: 2.5,
  MEDIUM_MAX: 10
})

const getLatencyState = (seconds, quote) => {
  if (seconds == null) return null
  if (seconds < LATENCY_THRESHOLD_SECONDS.LOW_MAX + quote) return STATUS_STATE.LOW_LATENCY
  if (seconds < LATENCY_THRESHOLD_SECONDS.MEDIUM_MAX + quote) return STATUS_STATE.MEDIUM_LATENCY
  return STATUS_STATE.HIGH_LATENCY
}

export const isOutOfMarketHours = (openingTime, closingTime) => {
  const now = new Date()
  const nowMinutes = now.getHours() * 60 + now.getMinutes()
  return nowMinutes >= timeToMinutes(closingTime) || nowMinutes < timeToMinutes(openingTime)
}

export const mapAndFlattenProperty = (obj, property) => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      const localValue = { ...value }
      const propertyValue = localValue[property]
      delete localValue[property]
      return [
        key,
        {
          currency: key,
          ...localValue,
          ...propertyValue
        }
      ]
    })
  )
}

export const mapAndParseFloatProperties = (obj, properties) => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      const parsed = { ...value }
      properties.forEach((prop) => {
        if (Object.prototype.hasOwnProperty.call(parsed, prop)) {
          parsed[prop] = parseFloat(parsed[prop])
        }
      })
      return [key, parsed]
    })
  )
}

export const mergeExchangeRateWithCurrencyConfig = (currencyConfigsObj, exchangeObj) => {
  Object.entries(exchangeObj).forEach(([currencyCode, value]) => {
    const parts = value.split('|')
    currencyConfigsObj[currencyCode] = {
      ...currencyConfigsObj[currencyCode],
      lastQuote: parseFloat(parts[4]),
      lastQuoteAt: parts[5]
    }
  })
  return currencyConfigsObj
}

export const calculateDelayProperties = (currencyConfigsObj, isMarketClosed) => {
  Object.keys(currencyConfigsObj).forEach((code) => {
    const lastMs = parseIsoToMs(currencyConfigsObj[code].lastQuoteAt)
    const nowUtcMinus3Hours = new Date(Date.now() - 3 * 60 * 60 * 1000)
    const latencySeconds =
      lastMs != null ? Math.max(0, Math.floor((nowUtcMinus3Hours - lastMs) / 1000)) : null
    currencyConfigsObj[code].latencySeconds = latencySeconds
    currencyConfigsObj[code].latencyState = isMarketClosed
      ? STATUS_STATE.OFF_MARKET
      : getLatencyState(latencySeconds, currencyConfigsObj[code].quote)
  })
  return currencyConfigsObj
}

export const nestCurrencyObjProperties = (currenciesObj) => {
  return Object.fromEntries(
    Object.entries(currenciesObj).map(([key, value]) => {
      return [
        key,
        {
          eventual_exchange_spread_increase: value.eventual_exchange_spread_increase.toString(),
          send_throttling_secs: {
            eventual: value.eventual,
            quote: value.quote.toString(),
            target_tax: value.target_tax,
            target_tax_alert: value.target_tax_alert
          }
        }
      ]
    })
  )
}

export const generateProviderCurrencyId = (b, c) => {
  return `${b}|${c}`
}
